import webosKit from "../libs/webOSTVjs-1.2.0/webOSTV";
const UAParser = require("ua-parser-js");
const userAgentParser = new UAParser();
// Default hardcoded key
let deviceId = '';
let deviceRealModel = "";
let deviceFirmwareVersion = "";
let serverVersion = "";
 
export const device = {
  async getId() {
    webOS.service.request("luna://com.webos.service.sm", {
        method: "deviceid/getIDs",
        parameters: {
            "idType": ["LGUDID"]
        },
        onSuccess: function (inResponse) {
          deviceId = inResponse.idList[0].idValue;
          console.log("success = "+ deviceId)
        },
        onFailure: function (inError) {
          // Default hardcoded key
          console.log("Reterving deviceID failed");
          deviceId = '06e16c5a-f9cc-f25d-4d8d-c2c0280b9278';
        }
      });
      return deviceId;
  },

  async getModel() {
    return "LG TV";
  },

  async getModelCode() {
    return "";
  },

  async getRealModel() {
          const  request = webOS.service.request("luna://com.webos.service.tv.systemproperty", {
          method: "getSystemInfo",
          parameters: { 
              "keys": ["modelName"]
          },
          onComplete: function (inResponse) {
              const isSucceeded = inResponse.returnValue;
      
              if (isSucceeded){
                deviceRealModel = inResponse.modelName;
              } else {
                  deviceRealModel = "";
              }
          }
      });
      return deviceRealModel; 
  },

  async getPlatform() {
    return "webos";
  },

  async getServerVersion() {
          const  request = webOS.service.request("luna://com.webos.service.tv.systemproperty", {
          method: "getSystemInfo",
          parameters: { 
              "keys": ["sdkVersion"]
          },
          onComplete: function (inResponse) {
              const isSucceeded = inResponse.returnValue;
      
              if (isSucceeded){
                serverVersion = inResponse.sdkVersion;
                localStorage.setItem("lgSdkVersion", (inResponse.sdkVersion.split('.'))[0]);
              } else {
                  serverVersion = "";
              }
             
            }
      });
      return serverVersion;
  },

  async getYear() {
    return "";
  },

  async supports4K() {
    return false;
  },

  async getFirmwareVersion() {
          const  request = webOS.service.request("luna://com.webos.service.tv.systemproperty", {
          method: "getSystemInfo",
          parameters: { 
              "keys": ["firmwareVersion"]
          },
          onComplete: function (inResponse) {
              const isSucceeded = inResponse.returnValue;
      
              if (isSucceeded){
                deviceFirmwareVersion = inResponse.firmwareVersion;
              } else {
                  deviceFirmwareVersion = "";
              }
          }
      });
      return deviceFirmwareVersion;
  },

  getManufacturer() {
    return "LG";
  },

  getType() {
    return "TV";
  }
};
